import { Component, Inject, Input } from '@angular/core';
import { filter, first, of, Subject, switchMap, takeUntil } from 'rxjs';
import { AppEnvironmentState, Environment, LIBRARY_CONFIG, UserState } from '../../../shared';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../../../shared";
import * as i3 from "@angular/common/http";
import * as i4 from "@angular/common";
import * as i5 from "./version-popup/version-popup.component";
import * as i6 from "@ngx-translate/core";
function EnvironmentTagComponent_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "geaui-version-popup", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("show-tooltip", ctx_r1.showTooltip);
    i0.ɵɵadvance();
    i0.ɵɵproperty("frontendVersion", ctx_r1.frontendVersion)("backendVersion", ctx_r1.backendVersion)("libVersion", ctx_r1.libVersion)("dbVersion", ctx_r1.dbVersion);
  }
}
function EnvironmentTagComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("mouseenter", function EnvironmentTagComponent_div_0_Template_div_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showTooltip = true);
    })("mouseleave", function EnvironmentTagComponent_div_0_Template_div_mouseleave_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showTooltip = false);
    });
    i0.ɵɵelementStart(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, EnvironmentTagComponent_div_0_div_5_Template, 2, 6, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "environment-tag-type-" + ctx_r1.environment);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.isMobile ? i0.ɵɵpipeBind1(3, 3, "UI-LIB.HEADER.ENVIRONMENT_TAG." + ctx_r1.environment.toUpperCase()).substring(0, 3) : i0.ɵɵpipeBind1(4, 5, "UI-LIB.HEADER.ENVIRONMENT_TAG." + ctx_r1.environment.toUpperCase()), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.frontendVersion);
  }
}
export class EnvironmentTagComponent {
  store;
  infoApi;
  httpClient;
  isMobile = false;
  environment = null;
  frontendVersion = '';
  backendVersion = '';
  dbVersion = '';
  libVersion = '';
  destroyed$ = new Subject();
  showTooltip = false;
  backendInfoUrl;
  constructor(store, infoApi, httpClient, libConfig) {
    this.store = store;
    this.infoApi = infoApi;
    this.httpClient = httpClient;
    this.backendInfoUrl = libConfig.backendInfoUrl;
  }
  ngOnInit() {
    this.store.select(AppEnvironmentState.appEnvironmentState).pipe(takeUntil(this.destroyed$), filter(state => state?.environment !== null)).subscribe(({
      environment
    }) => {
      this.environment = environment;
      if (environment && environment !== Environment.PROD) {
        this.fetchInfo();
      }
    });
  }
  fetchInfo() {
    this.infoApi.getFrontendVersions().pipe(first()).subscribe(versions => {
      if (versions) {
        this.frontendVersion = this.formatVersion(versions.app, versions.timestamp, versions.branch);
        this.libVersion = versions.lib;
      } else {
        console.warn('Versions are missing. Please configure a versions.json in your app assets folder.');
      }
    });
    this.store.select(UserState.token).pipe(filter(token => !!token), switchMap(() => this.backendInfoUrl ? this.httpClient.get(`${this.backendInfoUrl}`) : of({})), first()).subscribe(info => {
      this.dbVersion = info.databaseSchema?.version ?? '';
      this.backendVersion = this.formatVersion(info.build?.version ?? '', info.build?.timestamp ?? '', info.git?.branch ?? '');
    });
  }
  formatVersion(version, timestamp, branch) {
    return `${version} (Time: ${timestamp}, Branch: ${branch})`;
  }
  ngOnDestroy() {
    this.destroyed$.next();
  }
  static ɵfac = function EnvironmentTagComponent_Factory(t) {
    return new (t || EnvironmentTagComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.InfoService), i0.ɵɵdirectiveInject(i3.HttpClient), i0.ɵɵdirectiveInject(LIBRARY_CONFIG));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: EnvironmentTagComponent,
    selectors: [["geaui-environment-tag"]],
    inputs: {
      isMobile: "isMobile"
    },
    decls: 1,
    vars: 1,
    consts: [["class", "environment-tag-box", 3, "ngClass", "mouseenter", "mouseleave", 4, "ngIf"], [1, "environment-tag-box", 3, "mouseenter", "mouseleave", "ngClass"], [1, "environment-tag-text"], ["class", "environment-tag-tooltip-container", 3, "show-tooltip", 4, "ngIf"], [1, "environment-tag-tooltip-container"], [1, "environment-tag-tooltip", 3, "frontendVersion", "backendVersion", "libVersion", "dbVersion"]],
    template: function EnvironmentTagComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, EnvironmentTagComponent_div_0_Template, 6, 7, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.environment && ctx.environment !== "prod");
      }
    },
    dependencies: [i4.NgClass, i4.NgIf, i5.VersionPopupComponent, i6.TranslatePipe],
    styles: [".environment-tag-box[_ngcontent-%COMP%]{height:32px;padding:0 16px;font-weight:400;font-size:18px;cursor:default;display:flex;align-items:center}.environment-tag-box[_ngcontent-%COMP%]   .environment-tag-text[_ngcontent-%COMP%]{color:var(--geaui-black)}.environment-tag-box.environment-tag-type-local[_ngcontent-%COMP%], .environment-tag-box.environment-tag-type-dev[_ngcontent-%COMP%], .environment-tag-box.environment-tag-type-test[_ngcontent-%COMP%], .environment-tag-box.environment-tag-type-uat[_ngcontent-%COMP%]{background-color:var(--geaui-yellow)}.environment-tag-tooltip-container[_ngcontent-%COMP%]{position:absolute;display:none;top:6px;z-index:200}.environment-tag-tooltip-container.show-tooltip[_ngcontent-%COMP%]{display:initial}.environment-tag-tooltip-container[_ngcontent-%COMP%]   .environment-tag-tooltip[_ngcontent-%COMP%]{position:relative;left:-16px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EnvironmentTagComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-environment-tag',
      template: "<div\n  class=\"environment-tag-box\"\n  *ngIf=\"environment && environment !== 'prod'\"\n  [ngClass]=\"'environment-tag-type-' + environment\"\n  (mouseenter)=\"showTooltip = true\"\n  (mouseleave)=\"showTooltip = false\">\n  <span class=\"environment-tag-text\">\n    {{\n      isMobile\n        ? ('UI-LIB.HEADER.ENVIRONMENT_TAG.' + environment.toUpperCase() | translate).substring(0, 3)\n        : ('UI-LIB.HEADER.ENVIRONMENT_TAG.' + environment.toUpperCase() | translate)\n    }}\n  </span>\n  <div class=\"environment-tag-tooltip-container\" *ngIf=\"frontendVersion\" [class.show-tooltip]=\"showTooltip\">\n    <geaui-version-popup\n      class=\"environment-tag-tooltip\"\n      [frontendVersion]=\"frontendVersion\"\n      [backendVersion]=\"backendVersion\"\n      [libVersion]=\"libVersion\"\n      [dbVersion]=\"dbVersion\"></geaui-version-popup>\n  </div>\n</div>\n",
      styles: [".environment-tag-box{height:32px;padding:0 16px;font-weight:400;font-size:18px;cursor:default;display:flex;align-items:center}.environment-tag-box .environment-tag-text{color:var(--geaui-black)}.environment-tag-box.environment-tag-type-local,.environment-tag-box.environment-tag-type-dev,.environment-tag-box.environment-tag-type-test,.environment-tag-box.environment-tag-type-uat{background-color:var(--geaui-yellow)}.environment-tag-tooltip-container{position:absolute;display:none;top:6px;z-index:200}.environment-tag-tooltip-container.show-tooltip{display:initial}.environment-tag-tooltip-container .environment-tag-tooltip{position:relative;left:-16px}\n"]
    }]
  }], () => [{
    type: i1.Store
  }, {
    type: i2.InfoService
  }, {
    type: i3.HttpClient
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [LIBRARY_CONFIG]
    }]
  }], {
    isMobile: [{
      type: Input
    }]
  });
})();
